import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import { Link } from 'react-router-dom';

function Onsites() {

  const {user}                                                      = useSelector((state) => state.auth);
  const [listOnvites, setListOnvites]                               = useState([]);

  const [page, setPage]                                             = useState(1);

  useEffect(() => {
    collectListOfOnvites();
  },[])

  const collectListOfOnvites = async () =>{
    try{  

      const response = await axios.get(CONSTANTS.API_URL +"annivites/list/v1/onvite/" + page, {
            headers: {
              token: 'Bearer ' + user.accessToken,
            },
          });
         
          setListOnvites(response.data);
    }catch(err){
      console.log(err);
    }
  } 

  return (
    <div className="card">
      <div className="card-body">
          <h3 className="inner-part">Onsites List</h3>
          {
            listOnvites.length > 0 && (
              <div className="row-table-content">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>NO</th>
                        <th>Username</th>
                        <th>Spouse A</th>
                        <th>Spouse B</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>#</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                          listOnvites.map((item) => {
                            return <tr key={item._id}>
                                    <td></td>
                                    <td>{item.userName}</td>
                                    <td>{item.spouseA}</td>
                                    <td>{item.spouseB}</td>
                                    <td>{item.weddingDate}</td>
                                    <td>{item.weddingTime}</td>
                                    <td>{item.onviteDetails?.mainStart}</td>
                                    <td>{item.onviteDetails?.mainEnd}</td>
                                    <td>
                                      <Link to={'/annisite-details/' + item._id} className="btn btn-primary"> View
                                      </Link>
                                    </td>
                                  </tr>
                          })
                        }
                    </tbody>
                  </table>
              </div>
            )
          }
      </div>
    </div>
  )
}

export default Onsites